import React from 'react';
import classNames from 'classnames/bind';
import styles from './DefaultLayout.module.scss';
import { Layout } from 'antd';
import HeaderLayout from '../Header/HeaderLayout';
import BackToTopButton from '../../components/Scroll/BackToTopButton';

const cx = classNames.bind(styles);
const { Content } = Layout;

const DefaultLayout = ({ children }) => {
    return (
        <Layout className={cx('layout')}>
            <HeaderLayout />
            <Content className={cx('content')}>{children}</Content>
            <BackToTopButton />
        </Layout>
    );
};

export default DefaultLayout;
